module.exports = "/_next/static/images/exploded-3da1aa1ca80f2b5dfd10c6de325ccd35.png";